<template>
  <div class="scroll_flex_container">
    <!-- <div ref="processBar" style="width: 100%"> -->
    <Process></Process>
    <!-- </div> -->
    <Ordering v-if="getUrlParameters.process === 'ordering'"></Ordering>
    <OrderConfirm
      v-else-if="getUrlParameters.process === 'orderConfirm'"
    ></OrderConfirm>
  </div>
</template>
<script>
import process from "@/components/store/process.vue";
import Ordering from "@/views/store/Ordering.vue";
import OrderConfirm from "@/views/store/OrderConfirm.vue";
import { mapState } from "vuex";
export default {
  components: {
    Process: process,
    Ordering: Ordering,
    OrderConfirm: OrderConfirm,
  },
  data() {
    return {};
  },
  beforeMount() {
    //TODO: 改成使用 cart module
    // const storeData = commonUtilities.getLocalStorageItem(this.currentStore)
    // if (storeData?.cart) {
    //   this.$store.dispatch("cart/setCart", storeData.cart)
    // }
  },
  computed: {
    ...mapState("basic", {
      currentStore: "currentStore",
    }),
    getUrlParameters() {
      return this.$route.params;
    },
  },
  methods: {},
  beforeRouteEnter(to, from, next) {
    if (from.params.process === "orderPayment" && to.name !== "ordering") {
      console.log("從訂單付款頁面離開", to, from);
      next({ path: `/${to.params.store}/store` });
    } else {
      next();
    }
  },
};
</script>
<style lang="scss">
.cat_row {
  width: 100%;
  flex-shrink: 0;
  background-color: #fff;
  box-shadow: -1px 0px 6px 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: -1px 0px 6px 6px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: -1px 0px 6px 6px rgba(0, 0, 0, 0.1);
}

.categories {
  font-size: 18px;
  font-family: PingFang SC;
  font-size: 500;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
  flex-grow: 1;
  min-width: 0;
  padding: 5px 3%;
  overflow-x: auto;
}

.categories::-webkit-scrollbar {
  display: none;
}

.cat_more {
  width: 46px;
  flex-shrink: 0;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-left: 1px solid #e5e7eb;
  background-color: #fff;
  color: #fd5001;
  cursor: pointer;
}

.cat_more:active {
  background-color: #fff3ec;
}

.categories div {
  padding: 12px;
  cursor: pointer;
  border-radius: 10px;
  white-space: nowrap;
}

.categories div.active {
  background-color: #fd5001;
  color: #fff;
}

.products {
  overflow-y: auto;
  flex-grow: 1;
  width: 100%;
  padding: 0 7% calc(100px + env(safe-area-inset-bottom));
  background-color: #fff;
}

.product {
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px dotted #000;
  flex-shrink: 0;
  margin-bottom: 15px;
}

.cat_sheet_mask {
  position: fixed;
  inset: 0;
  z-index: 60;
  background-color: rgba(0, 0, 0, 0.35);
}

.cat_sheet {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 61;
  width: 74%;
  max-width: 280px;
  background-color: #fff;
  box-shadow: -8px 0 24px rgba(15, 23, 42, 0.18);
}

.cat_sheet_head {
  width: 100%;
  flex-shrink: 0;
  padding: 14px 10px 14px 16px;
  border-bottom: 1px solid #ffd9c6;
  background-color: #fff9dc;
  color: #4b2c18;
  font-size: 16px;
  font-weight: 700;
}

.cat_sheet_close {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 8px;
  background: none;
  color: #8a5a3b;
  font-size: 18px;
  cursor: pointer;
}

.cat_sheet_list {
  width: 100%;
  flex-grow: 1;
  padding: 8px 0 calc(8px + env(safe-area-inset-bottom));
  overflow-y: auto;
  scrollbar-width: none;
}

.cat_sheet_list::-webkit-scrollbar {
  display: none;
}

.cat_sheet_item {
  width: 100%;
  padding: 14px 16px;
  border: 0;
  border-bottom: 1px solid #f4f4f4;
  background: none;
  color: #333;
  font-size: 15px;
  text-align: left;
  cursor: pointer;
}

.cat_sheet_item.active {
  background-color: #fff3ec;
  color: #fd5001;
  font-weight: 700;
}

/* 滑入／淡入動畫 */
.cat_sheet-enter-active,
.cat_sheet-leave-active {
  transition: transform 0.25s ease;
}

.cat_sheet-enter-from,
.cat_sheet-leave-to {
  transform: translateX(100%);
}

.cat_mask-enter-active,
.cat_mask-leave-active {
  transition: opacity 0.2s ease;
}

.cat_mask-enter-from,
.cat_mask-leave-to {
  opacity: 0;
}
</style>
